import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {AddressForm} from "../../../../../website/authenticated/pages/account/components/address/AddressForm";
import {LoadingSpinner} from "../../../../../../core/ui/LoadingSpinner.jsx";
import {apiCreateAddress} from "../../../../../../client/state/UserAddressStore";


export class AddAddressComponent extends UI.Element {
    render() {
        return <AddressForm ref="form"/>;
    }

    isValid() {
        return true;
    }

    async getAddress() {
        if (!this.form.validateInputs()) {
            throw null;
        }
        LoadingSpinner.show();
        try {
            return await apiCreateAddress(this.form.getValues())
        } catch (error) {
            if (error?.fields) {
                this.form.displayFieldErrors(error);
                throw null;
            } else {
                throw error;
            }
        } finally {
            LoadingSpinner.hide();
        }
    }
}
